import React, {useEffect} from 'react'
import styles from './index.module.css'
import Button from '../../components/Button'
import {IoIosAdd} from 'react-icons/io'
import {useDispatch, useSelector} from 'react-redux'
import {useState} from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import {BiTrash} from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import {deleteApplicantGroup, getApplicantAddList, getApplicantAddNameExams, getApplicantGroupList, getApplicantNameExams, getApplicantPhysicalTraining} from '../../actions/applicantGroup'
import Loader from '../../components/Loader'
import Empty from '../../components/Empty'
import { getSchoolYears } from '../../actions/common'
import Title from '../../components/Title'
import Search from './Search'
import { getExamCityList } from '../../actions/exam_city'

export default function Index() {
    const dispatch = useDispatch();
    const {list, loading} = useSelector(state => state.applicant_group);
    const {schoolYears} = useSelector(state => state.common);
    
    const [params, setParams] = useState({school_year: 0});
    const [confirmation, setConfirmation] = useState(false);
    const [mode, setMode] = useState('general');
    const [id, setId] = useState(null);

    useEffect(() => {
    dispatch(getExamCityList());
    dispatch(getApplicantNameExams());
    dispatch(getApplicantPhysicalTraining());
    dispatch(getApplicantAddNameExams());
    dispatch(getApplicantAddList());
    }, []);

    useEffect(() => {
        dispatch(getSchoolYears())
    }, [])
    
    useEffect(() => {
        if (schoolYears.length) {
            setParams(prev => ({...prev, school_year: schoolYears?.find(el => el.actual === true)?.xp_key}))
        }
    }, [schoolYears])

    const handleGetData = () => { // Запрос на получение данных
        if (params.school_year === 0) return
        dispatch(getApplicantGroupList({...params}));
    }

    const acceptConfirmation = () => {
        closeModal();
        dispatch(deleteApplicantGroup(confirmation.id, params));
        setConfirmation(false);
      };
      const rejectConfirmation = () => {
        setConfirmation(false);
      };
    
      const openModal = (id) => () => setId(id)
    
      const closeModal = () => {
        setId(null);
        setMode('general');
        dispatch(getApplicantAddList());
      }

    const renderLi = (data) => {
        const {id, name, school_year, stream, class_year, applicant_count, closed} = data
        return (
            <tr key={id}>
                <td onClick={openModal(id)}>{name}</td>
                <td onClick={openModal(id)}>{school_year}</td>
                <td onClick={openModal(id)}>{stream}</td>
                <td onClick={openModal(id)}>{class_year}</td>
                <td onClick={openModal(id)}>{applicant_count}</td>
                <td onClick={openModal(id)}>{closed}</td>
                <td>
                    <i
                        className={styles.trash}
                        onClick={() => setConfirmation({id: id, name: name})}><BiTrash/></i>
                </td>
            </tr>
        )
    }

    const handleChange = (name, value) => { // Обработчик изменения параметров поиска
        setParams({
            ...params,
            [name]: value
        });
    }

    return (
        <div
            className={styles.wrapper}
            style={{
            width: '100%',
            margin: '0 auto'
        }}>

             

            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation?.id)}
                rejectConfirmation={rejectConfirmation}/>)}

            <Modal
                id={id}
                params={params}
                closeModal={closeModal}
                mode={mode}
                setMode={setMode}
                />

            <Title title='Экзаменационные группы'/>

            <Search params={params} schoolYears={schoolYears} handleChange={handleChange} handleGetData={handleGetData}/>

            {loading && <div className={styles.loader}><Loader /></div>}

            {!loading && !list?.length
                    ? <Empty/>
                    : <Table className={styles.tables}>
                        <thead>
                            <tr>
                                <th>Название</th>
                                <th>Год набора</th>
                                <th>Набор</th>
                                <th>Класс для поступления</th>
                                <th>Кол-во участников</th>
                                <th>Статус</th>
                                <th width={'1.5rem'}>Удалить</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list?.map(renderLi)}
                        </tbody>
                    </Table>}

            <div
                style={{
                display: 'flex',
                flexDirection: "row"
            }}>
                <Button
                    style={{
                    padding: '.5rem 1.5rem',
                    margin: '12px'
                }}
                    onClick={openModal('add')}>
                    <IoIosAdd size={30}/>
                    Добавить
                </Button>
            </div>
        </div>
    )
}
